module.exports = __webpack_public_path__ + "static/media/Character.20d30bae.png";